// Injected at build time via Dockerfile ARG
export const BUILD_TIMESTAMP = import.meta.env.VITE_BUILD_TIMESTAMP || 'dev';
export const BUILD_VERSION = import.meta.env.VITE_BUILD_VERSION || 'unknown';
